class WaitingVerificationEmail {
    constructor() {
        this.changeEmailButton = $("#changeEmailButton");
        this.formContainer = $(".delphi-updateMail-form");
        this.emailInput = this.formContainer.find("#Email");
        this.delphiNumberInput = this.formContainer.find("#DelphiAccountNumber");
        this.emailRegex = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        this.emailInput.on("change", () => {
            this.enableOrDisbaleSubmitButton();
        });
        this.delphiNumberInput.on("change", () => {
            this.enableOrDisbaleSubmitButton();
        });
        $("#resendMailForm").on("submit", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.resendEmail(e);
        });
        $("#changeEmailForm").on("submit", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.updateEmail(e);
        });
    }
    /**
     * Enable or disable the change submit button
     */
    enableOrDisbaleSubmitButton() {
        if (this.emailRegex.test(this.emailInput.val()) && this.delphiNumberInput.val().length > 0)
            this.changeEmailButton.removeAttr("disabled");
        else
            this.changeEmailButton.attr("disabled", "disabled");
    }
    /**
     * Resend the confirmation email
     * @param event
     */
    resendEmail(event) {
        const form = event.currentTarget;
        const login = form.elements.namedItem("Login").getAttribute("value");
        $.ajax({
            url: form.action,
            method: form.method,
            data: { login: login },
            success: (data) => {
                $("#emailCorrectlyResent").find(".resend-email-msg").text(data.message);
                $("#emailCorrectlyResent").modal("show");
            }
        });
    }
    /**
     * Update the current distributor email
     * @param event
     */
    updateEmail(event) {
        let form = event.currentTarget;
        $.ajax({
            url: form.action,
            method: form.method,
            data: $(form).serialize(),
            success: (data) => {
                if (data.success) {
                    var splitSearch = window.location.search.split("=");
                    splitSearch[1] = data.login;
                    window.location.href = window.location.origin + window.location.pathname + splitSearch[0] + "=" + splitSearch[1];
                }
                else {
                    form.querySelector(".validation-message").textContent = data.message;
                    let submitButton = form.querySelector(".btn-delphi-loading");
                    //submitButton.classList.add("btn-delphi");
                    submitButton.classList.remove("btn-delphi-loading");
                }
            }
        });
    }
}

//# sourceMappingURL=registration.waiting.js.map
